import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import Cookies from 'js-cookie';

let showDialogFromContext = null;
const retryQueue = [];
let dialogShown = false;
export const injectShowDialog = (cb) => { showDialogFromContext = cb };

export const dynamicBaseQuery = async (args, WebApi, extraOptions) => {
  const rawBaseQuery = fetchBaseQuery({
    baseUrl: window.REACT_APP_BASE_URL,
    setCredentials: 'include', // cookies
    prepareHeaders: async (headers, { getState }) => {
      headers.set('Content-Type', 'application/json')
      const token = Cookies.get('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  })
  return rawBaseQuery(args, WebApi, extraOptions)
}


export const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await dynamicBaseQuery(args, api, extraOptions);

  if (result.error?.status === 401 && showDialogFromContext) {
    return new Promise((resolve, reject) => {
      retryQueue.push(() =>
        dynamicBaseQuery(args, api, extraOptions).then(resolve).catch(reject)
      );

      if (!dialogShown) {
        dialogShown = true;
        showDialogFromContext(() => {
          // This callback will run only once when "Stay" is clicked
          while (retryQueue.length > 0) {
            const retry = retryQueue.shift();
            retry(); // Execute queued retries
          }
          dialogShown = false;
        });
      }
    });
  }

  return result;
};

export const backendApi = createApi({
  reducerPath: 'backend',
  overrideExisting: true,
  baseQuery: baseQueryWithReauth,
  // refetchOnMountOrArgChange: 30,
  tagTypes: ['RawFiles'],
  endpoints: () => ({}),
})
